import { render, staticRenderFns } from "./ConfirmHeader.vue?vue&type=template&id=1c297fb3&"
import script from "./ConfirmHeader.vue?vue&type=script&lang=js&"
export * from "./ConfirmHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmHeader.vue?vue&type=style&index=0&id=1c297fb3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c297fb3')) {
      api.createRecord('1c297fb3', component.options)
    } else {
      api.reload('1c297fb3', component.options)
    }
    module.hot.accept("./ConfirmHeader.vue?vue&type=template&id=1c297fb3&", function () {
      api.rerender('1c297fb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ConfirmHeader.vue"
export default component.exports